import React from "react";
import { BrowserRouter } from "react-router-dom";

import { AppRoutes } from "./Routes";
import { FirebaseProvider } from "./context/FirebaseContext";
import { ErrorHandler } from "./components/ErrorBoundary/ErrorBoundary";
import { UserContextProvider, useUserContext } from "./context/UserContext";
import { ThemeProvider } from "./components/ThemeProvider/ThemeProvider";
import { LayoutContextProvider } from "./context/LayoutContext";

interface AppProps {
  /** Optional replacement react-router implementation. */
  router?: React.ComponentType<any>;

  /** Forces app to render desktop layout */
  forceDesktopLayout?: boolean;
}

export const App = ({ router, forceDesktopLayout }: AppProps) => {
  // Allows the Router implementation to be replaced by tests.
  const Router = router ?? BrowserRouter;

  const css = `
    .ql-editor {
      min-height: 300px;
    }
    .richtext-content ol {
      margin-left: 10px;
      list-style-type: lower-alpha;
    }
    .richtext-content ol ol {
      margin-left: 20px;
      list-style-type: lower-roman;
    }
    .richtext-content ol ol ol {
      margin-left: 20px;
      list-style-type: decimal-leading-zero;
    }
    
    .richtext-content ol li {
      margin-left: 8px;
    }
  `;

  return (
    <div>
      <style>{css}</style>
      <ErrorHandler
        renderErrorState={(onReset) => {
          return <button onClick={onReset}>Reset</button>;
        }}
      >
        <FirebaseProvider>
          <ThemeProvider>
            <LayoutContextProvider forceDesktopLayout={forceDesktopLayout}>
              <UserContextProvider>
                <Router>
                  <AppRoutes />
                </Router>
              </UserContextProvider>
            </LayoutContextProvider>
          </ThemeProvider>
        </FirebaseProvider>
      </ErrorHandler>
    </div>
  );
};
